const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Portfolio', href: '#portfolio' },
  { label: 'Contact', href: '#contact' },
  { label: 'Privacy Policy', href: '#' },
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#f9f5f1] pt-10 sm:pt-12 pb-6">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-10 mb-8">
          {/* Logo + Description */}
          <div className="sm:col-span-2 md:col-span-1">
            <img
              src="https://cdn1.npcdn.net/images/np_25709_1707186562.png"
              alt="THIRD STUDIO"
              className="h-10 sm:h-12 object-contain mb-4"
            />
            <p className="text-sm text-gray-600 leading-relaxed">
              Insglobal creation, located both in Penang and Kuala Lumpur and available to be
              booked overseas, is a company specialize in providing professional makeup and
              hairstyling services for private events/corporate, and also film and TV. They also
              cater professional makeup courses by schedule that is designed for beginners as well
              as the pro in the industry.
            </p>
          </div>

          {/* Discover links */}
          <div>
            <h5 className="text-base font-semibold text-gray-800 mb-4">Discover</h5>
            <ul className="space-y-2">
              {NAV_LINKS.map(link => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={e => { e.preventDefault(); handleNav(link.href); }}
                    className="text-sm text-gray-600 hover:text-gray-800 cursor-pointer transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h5 className="text-base font-semibold text-gray-800 mb-4">Contact Us</h5>
            <div className="flex gap-2 mb-3">
              <i className="ri-map-pin-2-fill text-gray-500 mt-0.5 shrink-0" />
              <p className="text-sm text-gray-600 leading-relaxed">
                UNIT C-LG-07,<br />
                SFERA RESIDENCY,<br />
                JALAN ATMOSPHERE 1,<br />
                BANDAR PUTRA PERMAI,<br />
                43300 SERI KEMBANGAN,<br />
                SELANGOR.
              </p>
            </div>
            <a href="tel:+60174866108" className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-800 mb-4">
              <i className="ri-phone-line text-gray-500" />
              +6017-4866108
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-200 pt-5 sm:pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500 text-center sm:text-left">
            &copy; 2024-2026 <strong>THIRD STUDIO</strong>
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://www.facebook.com/insglobalmy/"
              target="_blank"
              rel="nofollow noreferrer"
              className="w-8 h-8 flex items-center justify-center bg-gray-200 rounded-full hover:bg-gray-300 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-sm text-gray-700" />
            </a>
            <a
              href="https://www.instagram.com/insglobalmy_official/"
              target="_blank"
              rel="nofollow noreferrer"
              className="w-8 h-8 flex items-center justify-center bg-gray-200 rounded-full hover:bg-gray-300 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-sm text-gray-700" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
